export enum SceneDefinitionSettingsMode {
    FREE = "FREE",
    STREETSIGHT = "STREETSIGHT",
}
